import { Renderer, Tokens } from 'marked';

type LinkRenderer = (this: Renderer, token: Tokens.Link) => string;

// Lesson step content links point to external resources; open them in a new tab
// so the student never leaves the platform. Mirrors the app's anchor convention
// (target="_blank" + rel="noopener noreferrer").
export function createMarkdownRenderer(): Renderer {
  const renderer = new Renderer();
  renderer.link = function (token) {
    // Delegate to the default anchor rendering (needs the parser bound at call
    // time via `this`), then inject the new-tab attributes.
    return (Renderer.prototype.link as LinkRenderer)
      .call(this, token)
      .replace('<a ', '<a target="_blank" rel="noopener noreferrer" ');
  };
  return renderer;
}
